import React, { useCallback, useEffect, useState } from "react";

import { useParams } from "react-router-dom";
import { Formik } from "formik";
import * as Yup from "yup";
import APIService from "../Services/API/APIService";
import {
  Form,
  Button,
  Card,
  Grid,
  Dimmer,
  Loader,
  Message,
  Container,

} from "semantic-ui-react";
import Navbar from "../Components/NavHeader";
import { toast } from "react-toastify";

const ResetPassword = (props) => {
  const [loading, setLoading] = useState(true);
  const [alert, setAlert] = useState({ show: false, message: "" });
  const params = useParams()
  const schema = Yup.object().shape({
    password: Yup.string().required('Required').min(8, 'Minimium password length is 8'),
    confirmPassword: Yup.string().required('Required').oneOf([Yup.ref('password'), null], 'Passwords must match')
  });


  const verifyToken = useCallback( async () => {
    try {
      setLoading(true);

      let result = await APIService.postDataNoAuth(
        "/auth/verifyForgotPassword",
        { token: params.token }
      );

      if (result) {
        APIService.storeToken(result.token)
      } else {

      }

      setLoading(false);
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    }
  },[params.token])

  useEffect(() => {
    let isSubscribed = true;

    verifyToken(isSubscribed);
    return () => (isSubscribed = false);
  }, [verifyToken]);

  const _resetPassword = async (values) => {
    try {
      if (values.password !== values.confirmPassword) {
        setAlert({
          show: true,
          message: "Your password does not match",
        });

        return;
      }

      setLoading(true);
      let response = await APIService.postData("/auth/resetPasswordGuestHouse", values);
      setLoading(true);


      if (response.success) {

        toast.success('Reset Successful')
        window.location.href = '/'
       
      }
 
    } catch (error) {
      console.log("error", error);
      setAlert({
        show: true,
        message: "An error occurred, please try again",
      });
      setLoading(false);
    }
  };

  return (
    <Container fluid>
      <Navbar />

      {loading ? (
        <Dimmer active inverted>
          <Loader />
        </Dimmer>
      ) : (


        <Grid centered >


          {alert?.show && (
            <Card centered>
              <Message negative>
                <p style={{ fontSize: '1.12em' }}>{alert.message}</p>
              </Message>
            </Card>
          )}

          <Grid.Row>
            <Card centered>
              <Card.Content>
                <Card.Meta style={{ color: "#00008b", fontSize: '1.25em' }}>Enter your new password </Card.Meta>
              </Card.Content>
              <Card.Content>
                <Formik
                  initialValues={{
                    password: '',
                    confirmPassword: ''
                  }}
                  validationSchema={schema}
                  onSubmit={(values) => _resetPassword(values)}
                >
                  {(props) => {
                    const {
                      values,
                      handleChange,
                      handleSubmit,
                      errors,
                      touched,
                    } = props;
                    return (
                      <Form onSubmit={handleSubmit}>
                        <Form.Group >

                          <Form.Input

                       
                            placeholder="Password"
                            name="password"
                            value={values.password}
                            onChange={handleChange}
                            error={touched.password && errors.password}
                            type='password'
                          />

                          </Form.Group>
                          <Form.Group>
                          <Form.Input


                            placeholder="Confirm Password"
                            name="confirmPassword"
                            value={values.confirmPassword}
                            onChange={handleChange}
                            error={touched.confirmPassword && errors.confirmPassword}
                            type='password'
                          />
                        </Form.Group>


                        <Button type="submit" style={{ backgroundColor: '#26f09e', color: '#000000' }}>
                          Update Password
                        </Button>

                      </Form>
                    );
                  }}
                </Formik>

              </Card.Content>
            </Card>
          </Grid.Row>
        </Grid>
      )}

    </Container>
  );
};

export default ResetPassword;
